import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Label,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import ApproveBloc from '../Approve/Blocs/ApproveBloc'
import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import moment from 'moment'

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;  
    while ( startYear <= currentYear ) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }   
    return years;
}

var reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
        var newObj = {};
        if (data['position_grade'] != null && data['position_grade'] > 0) {
            newObj["label"] = data[label] + ' (Grade ' + data['position_grade'] + ')';
        } else {
            newObj["label"] = data[label];
        }

        newObj["value"] = data[value];
        newObj["model"] = data;
        console.log(newObj);
        return newObj;
    });
};

class IndexView extends Component {

    createBloc = new CreateBloc();
    approveBloc = new ApproveBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                nip: "",
                nama: "",
                unit_kerja: "",
                jabatan: "",
                tmt_jabatan: "",
                golongan: "",
                tgl_lahir: "",
                jenis_kelamin: "",
                employee_front_title: "",
                employee_end_title: "",
            },
            employeeItems: [],
            employeeSelected: "",
            educationOptions: [],
            educationGroupOptions: [],
            yearOptions: createYearOption(new Date().getFullYear() - 100),
            type: 0,
            jabatanOption: [],
        }
    }

    reformatEmployee = (data) => {
        return data.map(function(item) {
          var newObj = {};
          newObj["label"] = item.employee_nip+" - "+item.employee_full_name;
          newObj["value"] = item.employee_uuid;
          newObj["model"] = item;
          return newObj;
        });
    };

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    dateParse = (input) =>{
      let res = "";
      if (input != "" && input != null){
        res = moment(input).format('DD/MM/YYYY')
      }
      return res;
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, ['file_sk', 'file_ijazah', 'file_penyetaraan', 'file_akre','sk_tubel','surat_izin_belajar','surat_kronologi','nota_dinas','sk_pangkat']) // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreate(formData)
        console.log(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values,
              education_background_status: 0 // menunggu approve
            },
            confirm: true
        })
    }

    onChangeEmployee = (employee) => {
        var model = employee.model
        this.setState({
            employeeSelected: employee.value,
            dataForm: {
                nip: model.employee_nip,
                nama: model.employee_full_name,
                unit_kerja: model.employee_current_work_unit_name,
                jabatan: model.employee_current_position_name,
                tmt_jabatan: model.employee_current_tmt_position,
                golongan: model.employee_current_rank_group_room,
                tgl_lahir: model.employee_date_of_birth,
                jenis_kelamin: model.employee_gender_name,
                employee_front_title: model.employee_front_title,
                employee_end_title: model.employee_end_title,
            }
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.createBloc.employeeChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      this.setState({
                          employeeItems: this.reformatEmployee(response.result)
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
        })  

        this.createBloc.educationChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      this.setState({
                          educationOptions: this.reformatOptions(
                            response.result,
                            "education_name",
                            "education_uuid"
                          )
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
        })  

        this.createBloc.educationGroupChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      this.setState({
                          educationGroupOptions: this.reformatOptions(
                            response.result,
                            "education_group_name",
                            "education_group_uuid"
                          )
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
          }
        }) 
        
        this.approveBloc.listJabatanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        this.setState({ positionOption: result.data.response.result, loadingPosition: false })
                    this.setState({ jabatanOption: reformatOptions(result.data.response.result, 'position_name', 'position_uuid') })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })  
        this.approveBloc.fetchListJabatan()
        
        this.createBloc.fetchEmployee()
        this.createBloc.fetchEducation({is_college: 1})
        this.createBloc.fetchEducationGroup()
    }

    componentWillUnmount(){
        this.createBloc.createChannel.unsubscribe()
        this.createBloc.employeeChannel.unsubscribe()
        this.createBloc.educationChannel.unsubscribe()
        this.createBloc.educationGroupChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Pencantuman Gelar</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pilih Pegawai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <Select
                                                    value={this.state.employeeItems.filter(option => 
                                                      option.value === this.state.employeeSelected)}
                                                    onChange={
                                                      this.onChangeEmployee
                                                    }
                                                    required="required"
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pegawai"
                                                />
                                                <AvField
                                                    name="education_background_employee_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="education_background_employee_uuid"
                                                    value={this.state.employeeSelected}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            NIP 
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="nip"
                                                    id="nip"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nip}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama 
                                            </label>
                                            <Col md="5">
                                                 <AvField
                                                    placeholder=""
                                                    name="nama"
                                                    id="nama"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nama}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Unit Kerja
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="unit_kerja"
                                                    id="unit_kerja"
                                                    readonly="readonly"
                                                    type="textarea"
                                                    className="form-control"
                                                    value={this.state.dataForm.unit_kerja}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jabatan 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="jabatan"
                                                    id="jabatan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.jabatan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Jabatan 
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    placeholder=""
                                                    name="tmt_jabatan"
                                                    id="tmt_jabatan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.dateParse(this.state.dataForm.tmt_jabatan)}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Golongan 
                                            </label>
                                            <Col md="1">
                                                <AvField
                                                    placeholder=""
                                                    name="golongan"
                                                    id="golongan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.golongan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Lahir 
                                            </label>
                                            <Col md="2">
                                                <AvField
                                                    placeholder=""
                                                    name="tgl_lahir"
                                                    id="tgl_lahir"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.dateParse(this.state.dataForm.tgl_lahir)}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Kelamin 
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="jenis_kelamin"
                                                    id="jenis_kelamin"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.jenis_kelamin}
                                                />
                                            </Col>
                                        </Row>

                                        <hr />
                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-3 col-form-label"
                                            >
                                                Jenis Pencantuman Gelar <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <Select
                                                    name="employee_transfer_detail_type"
                                                    options={[
                                                        { value: 1, label: 'Tugas Belajar' },
                                                        { value: 2, label: 'Izin Belajar' },
                                                        { value: 3, label: 'Telah Memiliki sebelum CPNS' },
                                                    ]}
                                                    onChange={opt => this.setState({ type: opt.value })}
                                                    // defaultValue={detailMutasi?.employee_transfer_detail_type}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tingkat Pendidikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <CustomSelect 
                                                    name="education_background_education_uuid"
                                                    errorMessage="Pilih Tingkat Pendidikan"
                                                    options={this.state.educationOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tingkat Pendidikan"
                                                    // defaultValue={this.state.dataForm.education_background_education_uuid}
                                                />
                                            </Col>
                                        </Row>     

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Universitas / Perguruan Tinggi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                 <AvField
                                                    name="education_background_school_name"
                                                    id="education_background_school_name"
                                                    placeholder="Nama Universitas / Perguruan Tinggi"
                                                    type="text"
                                                    errorMessage="Masukan Nama Universitas / Perguruan Tinggi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row> 

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pendidikan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <CustomSelect 
                                                    name="education_background_education_group_uuid"
                                                    errorMessage="Pilih Rumpun"
                                                    options={this.state.educationGroupOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Rumpun"
                                                    // defaultValue={this.state.dataForm.education_background_education_uuid}
                                                />
                                            </Col>
                                        </Row>   

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jurusan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                 <AvField
                                                    name="education_background_school_major"
                                                    id="education_background_school_major"
                                                    placeholder="Jurusan"
                                                    type="text"
                                                    errorMessage="Masukan Jurusan"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>    */}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Alamat Universitas / Perguruan Tinggi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    name="education_background_school_address"
                                                    id="education_background_school_address"
                                                    placeholder="Alamat Universitas / Perguruan Tinggi"
                                                    type="text"
                                                    errorMessage="Masukan Alamat Universitas / Perguruan Tinggi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>  

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Ijazah <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                 <AvField
                                                    name="education_background_certificate_number"
                                                    id="education_background_certificate_number"
                                                    placeholder="Nomor Ijazah"
                                                    type="text"
                                                    errorMessage="Masukan Nomor Ijazah"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>  

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Ijazah <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_certificate_date"
                                                    id="education_background_certificate_date"
                                                    placeholder="Tanggal Ijazah"
                                                    type="date"
                                                    errorMessage="Masukan Tanggal Ijazah"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>        

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tahun Lulus <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="education_background_graduation_year"
                                                    errorMessage="Pilih Tahun Lulus"
                                                    options={this.state.yearOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tahun Lulus"
                                                    defaultValue={new Date().getFullYear()}
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor SK Pencantuman Gelar <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                 <AvField
                                                    name="education_background_title_sk_number"
                                                    id="education_background_title_sk_number"
                                                    placeholder="Nomor SK Pencantuman Gelar"
                                                    type="text"
                                                    errorMessage="Masukan Nomor SK Pencantuman Gelar"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>  

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal SK Pencantuman Gelar <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_title_sk_date"
                                                    id="education_background_title_sk_date"
                                                    placeholder="Tanggal SK Pencantuman Gelar"
                                                    type="date"
                                                    errorMessage="Masukan Tanggal SK Pencantuman Gelar"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>      */}

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Gelar Lengkap
                                            <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                 <AvField
                                                    name="education_background_title_text"
                                                    id="education_background_title_text"
                                                    placeholder="Nama Gelar Lengkap"
                                                    type="text"
                                                    errorMessage="Masukan Nama Gelar Lengkap"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                />
                                            </Col>
                                        </Row>   */}

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Gelar Depan 
                                            {/* <span className="text-danger">*</span> */}
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_front_title"
                                                    id="education_background_front_title"
                                                    placeholder="Gelar Depan"
                                                    type="text"
                                                    errorMessage="Masukan Gelar Depan"
                                                    className="form-control"
                                                    // validate={{ required: { value: false } }}
                                                    value={this.state.dataForm.employee_front_title}
                                                />
                                            </Col>
                                        </Row>    

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Gelar Belakang 
                                            {/* <span className="text-danger">*</span> */}
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_end_title"
                                                    id="education_background_end_title"
                                                    placeholder="Gelar Belakang"
                                                    type="text"
                                                    errorMessage="Masukan Gelar Belakang"
                                                    className="form-control"
                                                    // validate={{ required: { value: false } }}
                                                    value={this.state.dataForm.employee_end_title}
                                                />
                                            </Col>
                                        </Row> 

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Jabatan Yang Membidangi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                            <CustomSelect
                                                        name="education_background_parent_position_uuid"
                                                        options={this.state.jabatanOption}
                                                        //optionLabel="position_name"
                                                        //optionValue="position_uuid"
                                                        errorMessage="Pilih Jabatan Yang Membidangi"
                                                        // defaultValue={detailMutasi?.education_background_parent_position_uuid}
                                                        isLoading={this.state.loadingPosition}
                                                        validate={{ required: { value: true } }}
                                                    />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                                Lokasi Dikeluarkanya Ijazah <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <AvField
                                                    name="education_background_ijazah_location"
                                                    id="education_background_ijazah_location"
                                                    placeholder="Lokasi Dikeluarkannya Ijazah"
                                                    type="text"
                                                    errorMessage="Masukan Lokasi Dikeluarkannya Ijazah"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>      

                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Ijazah & Transkrip Nilai</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_ijazah"
                                                    col="2"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Akreditasi Program Studi</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_akre"
                                                    col="2"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Penyetaraan Ijazah Bagi Lulusan Luar Negeri</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_penyetaraan"
                                                    col="2"
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File SK Pencantuman Gelar</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file_sk"
                                                    col="2"
                                                />
                                            </Col>
                                        </Row>                   */}
                                        {(this.state.type == 1 )?
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">SK Tugas Belajar <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="sk_tubel"
                                                    validate={{ required: { value: true } }}
                                                    col="6"
                                                    />
                                            </Col>
                                        </Row>
                                        :""
                                        }
                                        
                                        {(this.state.type == 2)?
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Surat Izin Belajar <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="surat_izin_belajar"
                                                    validate={{ required: { value: true } }}
                                                    col="6"
                                                    />
                                            </Col>
                                        </Row>
                                        :""
                                        }
                                        {(this.state.type == 3)?
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Surat Kronologi</Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="surat_kronologi"
                                                    col="6"
                                                    />
                                            </Col>
                                        </Row>
                                        :""
                                        }
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Nota Dinas <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="nota_dinas"
                                                    validate={{ required: { value: true } }}
                                                    col="6"
                                                    />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">SK Pangkat Terakhir <span className="text-danger">*</span></Label>
                                            <Col md="6">
                                                <FileInput
                                                    name="sk_pangkat"
                                                    validate={{ required: { value: true } }}
                                                    col="6"
                                                    />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/pencantuman_gelar.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/pencantuman_gelar.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView